// Kept out of auth.ts so client components can use these without bundling the server NextAuth config.
export const AUTH_TYPES = {
  TRADITIONAL: "traditional",
  OTP: "otp",
  EMAIL_OTP: "email-otp",
  AGENT_PASSWORD: "agent-password",
} as const;

export type AuthType = (typeof AUTH_TYPES)[keyof typeof AUTH_TYPES];
